import { Fragment, ReactNode } from "react";
import NewUnifiedLogin from "../../pages/authentication/NewUnifiedLogin";

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const isAuthenticated = window.localStorage.getItem("user");

  if (!isAuthenticated) {
    return <NewUnifiedLogin />;
  }

  return <Fragment>{children}</Fragment>;
};

export default AuthGuard;
